import { Injectable } from '@angular/core';
import { AnnulationDemandeClientService } from '../../../../core/services/annulation-demande-client.service';
import { map, Observable } from 'rxjs';
import { RaisonAnnulation } from './raison-annulation-demande.model';
import { InlineResponse } from '../../../../core/models/inline-response.model';
import { ConsequenceAnnulation } from './consequence-annulation-demande.model';

@Injectable({
  providedIn: 'root',
})
export class ReferentialsAnnulationDemandeService {
  constructor(private annulationDemandeClientService: AnnulationDemandeClientService) {}

  getRaisonAnnulation(): Observable<RaisonAnnulation[]> {
    return this.annulationDemandeClientService.getRaisonAnnulation().pipe(
      map((raison) => raison.rows),
      map((rows) => rows.map((row) => new RaisonAnnulation(row.id, row.raison))),
    );
  }

  addRaisonAnnulation(raison: string): Observable<InlineResponse> {
    return this.annulationDemandeClientService.addRaisonAnnulation(raison);
  }

  updateRaisonAnnulation(raisonAnnulation: RaisonAnnulation): Observable<InlineResponse> {
    return this.annulationDemandeClientService.updateRaisonAnnulation(raisonAnnulation);
  }

  getConsequenceAnnulation(): Observable<ConsequenceAnnulation[]> {
    return this.annulationDemandeClientService.getConsequenceAnnulation().pipe(
      map((consequence) => consequence.rows),
      map((rows) => rows.map((row) => new ConsequenceAnnulation(row.id, row.consequence))),
    );
  }

  addConsequenceAnnulation(consequence: string): Observable<InlineResponse> {
    return this.annulationDemandeClientService.addConsequenceAnnulation(consequence);
  }

  updateConsequenceAnnulation(consequenceAnnulation: ConsequenceAnnulation): Observable<InlineResponse> {
    return this.annulationDemandeClientService.updateConsequenceAnnulation(consequenceAnnulation);
  }
}
